export default __webpack_public_path__ + "static/media/1270.226ec4a9.png";